import TYPES from './types';
import { Reducer } from 'redux';
import { IServerStatistics, ServerStatisticsDispatchAction } from './state';

const initialState : IServerStatistics | null = null;

const ServerStatisticsReducer : Reducer<IServerStatistics | null, ServerStatisticsDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case TYPES.FETCH_START:
                return state
            case TYPES.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default ServerStatisticsReducer;